export default "__VITE_ASSET__D25EkAN1__"